/* eslint-disable no-unused-vars */
import React, { useState, useCallback, useEffect, memo, useRef } from 'react';
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS Filenpm 
import {
	formatBlock,
	list,
} from "suneditor/src/plugins";
import "suneditor/dist/css/suneditor.min.css";
import "@/views/elements/suneditor-custom.css";

const TextEditor = ({
	defaultText = '',
	setFieldContent,
	placeholder = '',
	minHeight = 60,
	setAutoFocus = false,
	disableFormating = false,
	maxCharCount = null,
	buttonList = [
		[ "bold" ],
		[ "italic" ],
		[ "underline" ],
	],
}) => {
	const [ sunInstance, setSunInstance ] = useState(null);
	// const [ content, setContent ] = useState();
	// const [dynamicContent, setDynamicContent] = useState();

	const getSunEditorInstance = (instance) => {
		setSunInstance(instance);
	};

	useEffect(() => {
		if (!sunInstance || defaultText.length < 1) return;
		setTimeout(() => sunInstance.setContents(defaultText), 10);
		// setTimeout(() => console.log(sunInstance.core.getContents()), 2000);
	}, [ sunInstance ]);

	const handleEditorChange = useCallback((content) => {
		// console.log("handleContent:", content);
		setFieldContent(content);
		// setContent(content);
		// eslint-disable-next-line
    }, []);

	const handlePaste = (event, cleanData, maxCharCount) => {
		// console.log("handlePaste:", event, cleanData, maxCharCount);
		return true;
	};

	const handleDrop = (event) => {
		// console.log("handleDrop:", event);
		return false;
	};

	return (
		<SunEditor
			getSunEditorInstance={ getSunEditorInstance }
			onChange={ handleEditorChange }
			setDefaultStyle='height: auto'
			placeholder={ placeholder }
			autoFocus={ setAutoFocus }
			lang='pl'
			showToolbar={ !disableFormating }
			onPaste={ handlePaste }
			onDrop={ handleDrop }

			defaultStyle='font-family: cursive; font-size: 10px;'

			setOptions={ {
				showPathLabel: false,
				height: "auto",
				minHeight: `${minHeight}px`,
				maxHeight: "500px",
				placeholder: placeholder,
				resizingBar: false,
				tabDisable: true,
				maxCharCount: maxCharCount,
				charCounterLabel: 10,
				// codeMirror: {
				//   src: CodeMirror,
				//   options: {
				//     indentWithTabs: true,
				//     tabSize: 2
				//   }
				// },
				// requestHeaders: {
				//   "X-Sample": "sample"
				// },
				plugins: [
					// align,
					formatBlock,
					// fontColor,
					// hiliteColor,
					list,
					// table,
					// textStyle
					// image,
					// imageGallery
				],
				buttonList: buttonList,
			} }

		/>

	);
};
export default memo(TextEditor);

// setOptions={ {
//     buttonList: [
//         [
//             "bold",
//             "underline",
//             "italic",
//             "strike",
//             "list",
//             "align",
//             "fontSize",
//             "formatBlock",
//             "table",
//             "image",
//         ],
//     ],
// } }

{/* <SunEditor
			getSunEditorInstance={ getSunEditorInstance }
			autoFocus={ setAutoFocus }
			lang='pl'
			placeholder={ placeholder }
			// appendContents={content}
			showToolbar={ !disableFormating }
			setOptions={ {
				showPathLabel: false,
				height: "auto",
				minHeight: `${minHeight}px`,
				maxHeight: "500px",
				placeholder: placeholder,
				resizingBar: false,
				tabDisable: true,
				// codeMirror: {
				//   src: CodeMirror,
				//   options: {
				//     indentWithTabs: true,
				//     tabSize: 2
				//   }
				// },
				// requestHeaders: {
				//   "X-Sample": "sample"
				// },
				plugins: [
					// align,
					formatBlock,
					// fontColor,
					// hiliteColor,
					// list,
					// table,
					// textStyle
					// image,
					// imageGallery
				],
				buttonList: [
					// ["undo", "redo"],
					[
						"bold",
						"italic",
						"underline",
						// "strike",
						"subscript",
						"superscript",

						// "fontColor",
						// "hiliteColor",
						// "align"
						// "outdent",
						// "indent",
						// "list",
						// "removeFormat"
					],
					[ "removeFormat" ],
					// ["imageGallery", "table"],
					// ["showBlocks", "codeView"]
				],
			} }
			defaultStyle='font-family: cursive; font-size: 10px;'
			// setContents={ content }
			onChange={ handleContent }
			onPaste={ handlePaste }
			onDrop={ handleDrop }
		/> */}